var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-dialog', {
    staticClass: "schema-save",
    attrs: {
      "title": "保存为方案",
      "visible": _vm.value,
      "width": "50%",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": ""
    },
    on: {
      "open": _vm.handleOpen,
      "close": _vm.handleClose
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "label-tip"
  }, [_vm._v("请输入方案名称")]), _c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入方案名称"
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "name"
    }
  })], 1), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-checkbox', {
    staticClass: "fix-label",
    model: {
      value: _vm.isFixed,
      callback: function ($$v) {
        _vm.isFixed = $$v;
      },
      expression: "isFixed"
    }
  }, [_vm._v(" 固定至搜索栏 ")]), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取 消")]), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.handleSave
    }
  }, [_vm._v("保 存")])], 1)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };